import {format} from 'date-fns';

export const formatDate = dateString => {
  if (!dateString) return '-';
  const parsedDate = new Date(dateString); // ISO string handled natively
  if (isNaN(parsedDate.getTime())) return 'Invalid Date';
  return format(parsedDate, 'dd-MM-yyyy');
};

export const formatTime = dateString => {
  if (!dateString) return '-';
  try {
    const parsedDate = new Date(dateString);
    if (isNaN(parsedDate.getTime())) return 'Invalid Time';
    return format(parsedDate, 'hh:mm a');
  } catch (error) {
    return 'Invalid Time';
  }
};

export const formatSessionTime = time => {
  const [hours] = time.split(':').map(Number);
  const formatTime = hours >= 15 ? 'Evening' : 'Morning';
  return formatTime;
};

export const convertToLocal = dateString => {
  if (!dateString) return '';
  return dateString.split('+')[0].slice(0, 16);
};
